// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Z4eb","title":"Info_title__2ikpG","links":"Info_links__2lq0w","link":"Info_link__f4rma","logo":"Info_logo__3Twk7"};